import React, { useState, useEffect } from 'react';
import * as ErrorMessage from '../helpers/_ErrorMessage';
import * as Upload from '../Services/_fileUploadService';
import LoadingSpinner from '../helpers/_Loading';
import '../styles/_fileUpload.scss';
import { v4 as uuidv4 } from 'uuid';
import { config } from '../Services/_config';

export const UploadFiles = (props) => {
    const { maxNoFiles, maxFileSizeInMB } = config.fileUpload;
    const maxFileSizeInBytes = maxFileSizeInMB * 1024 * 1024;
    const [isLoading, setIsLoading] = useState(false);
    const {formName, utrn, uploadedFilesRef, _storageSetFiles, _storageGetFiles} = props;

    //
	const [error, setError] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState(_storageGetFiles());

    useEffect(() => {
        _storageSetFiles(uploadedFiles);
    },[uploadedFiles, _storageSetFiles]);

    const handleFileUpload = async(event) => {
        //Because this is an input inside a form, preventing the default behaviour of a button will stop bug on submtting the form
        event.preventDefault();
        setIsLoading(true);

        try {
            const selectedFile = event.target.files[0];
            if(selectedFile) {
                //Check if file has already been uploaded
                if (uploadedFiles.some(file => file.name === selectedFile.name)) {
                    setError({fileUpload: {
                        message:`Duplicated files are not allowed. A file with the same name has already been uploaded. Please select a different file.`
                    }});
                    return;
                }

                //Check if file is below limit, if not produce an error
                if(selectedFile.size < maxFileSizeInBytes) {
                    const isUploaded = await Upload.uploadFile(formName, utrn, selectedFile.name, selectedFile);
                    if(!isUploaded){
                        setError({fileUpload: {
                            message:`The selected file '${selectedFile.name}' could not be uploaded.`
                        }});
                    } else {
                        //Uses uploadedFiles state array for value - states is async
                        //Uses uniqueId value for id to prevent any collisions
                        setUploadedFiles(uploadedFiles => [...uploadedFiles, { id: uuidv4(), name:selectedFile.name }]);
                        setError(null);
                    }
                } else {
                    setError({fileUpload: {
                        message:`The selected file '${selectedFile.name}' must be smaller than ${maxFileSizeInMB}MB.`
                    }});
                }
            }
        } catch(error) {
            console.log({"error":error});
        } finally {
            setIsLoading(false);
        }
    }

    const handleDeleteFile = (id) => {
        setIsLoading(true);
        setUploadedFiles(uploadedFiles => uploadedFiles.filter(file => file.id !== id));
        setIsLoading(false);
    }

    const handleDeleteAllFiles = () => {
        setUploadedFiles([]);
    }

    return (
        <>
        { isLoading ? <LoadingSpinner isLoading={isLoading} /> :
            <div className="form-group">
                <label htmlFor="file-upload-1" className="form-label">Do you have any supporting documentation to upload that may help the referral?</label>
                <p>This could be up to {maxNoFiles} files and should be no more than {maxFileSizeInMB}MB in size.</p>

                { error &&
                    <div className='govuk-form-group govuk-form-group--error'>
                        <p id={`fileUpload-error`} className="error--message text-danger">
                            <span className="sr-only">Error:</span>
                            {error?.fileUpload.message}
                        </p>
                    </div>
                }
                {/* <ErrorMessage error={error.fileName} /> */}

                { uploadedFiles?.length < maxNoFiles &&
                    <label id="upload-file" className="btn btn-primary btn-small">
                        Select File
                        <input type="file" htmlFor="file" id="upload-file-btn" name="file" hidden="true" onChange={handleFileUpload}/>
                    </label>
                }

                <div className="form-group">
                    <div className="files">
                        <div className="files__toUpload">
                            { uploadedFiles.length > 0 &&
                                <>
                                    <h2 className="heading-medium">Files being uploaded</h2>
                                    <p>Number of files: {uploadedFiles.length}</p>
                                    <div className="form-group">
                                        <ul className="toUpload">
                                            {/* https://beta.reactjs.org/learn/rendering-lists */}
                                            { uploadedFiles.map((file) => (
                                                <li key={file.id}>
                                                    <p>{file.name}</p>
                                                    <a href='#' role="button" className="link--simple" onClick={() => {handleDeleteFile(file.id)}}>Remove</a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="form-group">
                                        <button className='btn btn-primary btn-small bottom' type="button" onClick={() => handleDeleteAllFiles()}>Remove all files</button>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    );
};
